import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/social/linkedin.svg")